import { ATTACHMENT_CREATE, ISSUE_SELECTED } from "../../typesAction";

const INITIAL_STATE = {
  selectedIssue: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case  ISSUE_SELECTED: {
      return {
        ...state,
        selectedIssue: action.payload.issue
      };
    }

    case  ATTACHMENT_CREATE: {
      let selectedIssue = { ...state.selectedIssue };
      selectedIssue.issueAttachments.push(action.payload.attachment);
      return {
        ...state,
        selectedIssue: selectedIssue
      };
    }

    default:
      return state;
  }
}
